import "rxjs/add/operator/catch";
import "rxjs/add/operator/map";
import {enableProdMode} from "@angular/core";
import {platformBrowserDynamic} from "@angular/platform-browser-dynamic";
import {TransitionToolModule} from "./transition-tool.module";
import {registerLocaleData} from "@angular/common";
import localeEn from "@angular/common/locales/en";

import "./style.scss";

enableProdMode();

registerLocaleData(localeEn, "en");

platformBrowserDynamic().bootstrapModule(TransitionToolModule);
